import { render } from "./CashierPayOrderPage.vue?vue&type=template&id=170970cf"
import script from "./CashierPayOrderPage.vue?vue&type=script&lang=js"
export * from "./CashierPayOrderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__